import React from 'react'
import { Route, Routes, Navigate, Outlet } from 'react-router-dom';
import {
	publicRoutes,
	privateRoutes,
	adminPrivateRoutes,
	deliveryPrivateRoutes,
	partnerPrivateRoutes,
} from './routes'

import Layout from 'containers/layout/owner/Layout';
import LayoutAdmin from 'containers/layout/admin/Layout';
import LayoutDelivery from 'containers/layout/delivery/Layout';
import LayoutPartner from 'containers/layout/partner/Layout';
import NoAuthLayout from 'containers/layout/NoAuthLayout';

function createPublicRoutes() {
	return publicRoutes.map((item, key) => {
		return (
			<Route key={key} path={item.path} element={item.component} />
		);
	});
}

function createPrivateRoutes() {
	const role = localStorage.getItem("role");

	if (role === 'ROLE_OWNER' || role === 'ROLE_DIRECTOR') {
		return privateRoutes.map((item, key) => {
			return (
				<Route key={key} element={<ProtectedRoute />}>
					<Route path={item.path} element={item.component} />
				</Route>
			);
		});
	}
}

function createAdminPrivateRoutes() {
	const role = localStorage.getItem("role");

	if (role === 'ROLE_ADMIN') {
		return adminPrivateRoutes.map((item, key) => {
			return (
				<Route key={key} element={<ProtectedAdminRoute />}>
					<Route path={item.path} element={item.component} />
				</Route>
			);
		});
	}
}

function createDeliveryPrivateRoutes() {
	const role = localStorage.getItem("role");

	if (role === 'ROLE_CALL_CENTER' || role === 'ROLE_OWNER') {
		return deliveryPrivateRoutes.map((item, key) => {
			return (
				<Route key={key} element={<ProtectedRoute />}>
					<Route path={item.path} element={item.component} />
				</Route>
			);
		});
	}
}

function createPartnerPrivateRoutes() {
	const role = localStorage.getItem("role");

	if (role === 'ROLE_PARTNER') {
		return partnerPrivateRoutes.map((item, key) => {
			return (
				<Route key={key} element={<ProtectedRoute />}>
					<Route path={item.path} element={item.component} />
				</Route>
			);
		});
	}
}

function createRedirectRoutes() {
	const role = localStorage.getItem("role");

	if (role === 'ROLE_ADMIN') {
		return (
			<Route path="*" element={<Navigate to="/admin/users" replace />} />
		);
	}
	if (role === 'ROLE_OWNER' || role === 'ROLE_DIRECTOR') {
		return (
			<Route path="*" element={<Navigate to="/dashboard-main" replace />} />
		);
	}
	if (role === 'ROLE_CALL_CENTER') {
		return (
			<Route path="*" element={<Navigate to="/delivery/orders" replace />} />
		);
	}
}

function ProtectedRoute() {
	const login = localStorage.getItem("login");
	var isAuthenticated = false;
	if (login) {
		isAuthenticated = true
	} else {
		isAuthenticated = false
	}

	if (!isAuthenticated) {
		localStorage.removeItem('login')
		localStorage.removeItem('role')
		localStorage.removeItem('token')
		return <Navigate to="/auth/login" />;
	}

	return <Outlet />;
};

function ProtectedAdminRoute() {
	const login = localStorage.getItem("login");
	const role = localStorage.getItem("role");

	var isAuthenticated = false;
	if (login === 'admin' && role === 'ROLE_ADMIN') {
		isAuthenticated = true
	} else {
		isAuthenticated = false
	}

	if (!isAuthenticated) {
		localStorage.removeItem('login')
		localStorage.removeItem('role')
		localStorage.removeItem('token')
		return <Navigate to="/auth/login" />;
	}

	return <Outlet />;
};

const Index = () => {
	return (
		<Routes>
			<Route element={<NoAuthLayout />}>
				{createPublicRoutes()}
			</Route>

			<Route element={<NoAuthLayout />}>
				<Route path="*" element={<Navigate to="/auth/login" replace />} />
			</Route>

			<Route element={<Layout />}>
				{createPrivateRoutes()}
			</Route>

			<Route element={<Layout />}>
				{createRedirectRoutes()}
			</Route>

			<Route path="/admin" element={<LayoutAdmin />}>
				<Route path="/admin" element={<Navigate to="/admin/users" replace />} />
				{createAdminPrivateRoutes()}
			</Route>

			<Route path="/delivery" element={<LayoutDelivery />}>
				{createDeliveryPrivateRoutes()}
			</Route>

			<Route path="/partner" element={<LayoutPartner />}>
				{createPartnerPrivateRoutes()}
			</Route>
		</Routes>
	)
}

export default Index;